import React from "react";
import { FilterOutlined } from "uiCore";

const SkillsBridgerPaginationTotal = ({ total, dataLength }) => {
  const hasActiveFilter = total < dataLength;

  return (
    <div className="paic-pagination-total">
      <FilterOutlined />
      <span className={hasActiveFilter ? "is-active-text" : "is-empty-text"}>
        {hasActiveFilter
          ? `${total} Skills selected`
          : "0 Skills selected. Please select at least one Skill"}
      </span>
    </div>
  );
};

export default SkillsBridgerPaginationTotal;
